import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

import * as SC from "./insightsLoadingRotatingSubtitle.styles";
import { useInsightsLoadingRotatingSubtitle } from "./useInsightsLoadingRotatingSubtitle";

export const InsightsLoadingRotatingSubtitle = () => {
    const { messageKey, onMotionTransitionEnd, slide } = useInsightsLoadingRotatingSubtitle();

    return (
        <SC.InsightsLoadingRotatingViewport data-automation={generateAutomationName("home", ["insights", "panel", "loading-subtitle"])}>
            <SC.InsightsLoadingRotatingMotion
                $slide={slide}
                onTransitionEnd={onMotionTransitionEnd}
            >
                <Text
                    color={colorsPalettes.carbon[300]}
                    fontVariant="body2"
                >
                    {translate(messageKey)}
                </Text>
            </SC.InsightsLoadingRotatingMotion>
        </SC.InsightsLoadingRotatingViewport>
    );
};
